import { createLabeledMessages } from '../../../messageUtils';
const address = {
    address: 'adresa',
    mailingAddress: 'korespondenční adresa',
    place: 'místo',
    city: 'město',
    street: 'ulice',
    village: 'obec',
    villagePart: 'část obec',
    postalCode: 'poštovní směrovací číslo',
    postalCode_short: 'PSČ',
    buildingNumber: 'číslo popisné',
    buildingNumber_short: 'ČP',
    orientationNumber: 'číslo orientační',
    flatZone: 'povodňová zóna',
    regionZone: 'regionální zóna'
};
export default Object.assign({}, address, createLabeledMessages(address));
